import { FeedbackCategories } from '@modules/feedback/components/FeedbackCard/FeedbackCategories';
import { SentimentPredictionLabel } from '@modules/feedback/components/FeedbackDetails/SentimentPredictionLabel';
import {
  getFeedbackLabels,
  mapEdgeSentimentNameToSentimentName,
} from '@modules/feedback/components/FeedbackDetails/utils';
import { useFeedbackOnFeedbackStore } from '@modules/feedback/store';
import { SetSelectedLabels } from '@modules/feedback/types';
import { getSentimentPrediction } from '@modules/feedback/utils';
import { Divider, Stack, Typography } from '@mui/material';
import { SentimentName } from 'generated/graphql';
import { useMemo } from 'react';
import {
  Feedback,
  FeedbackLabel,
  FeedbackLabelType,
} from 'v2/core/entities/feedback';
import { SentimentLabel } from 'v2/core/entities/feedback/labels';

interface FeedbackDetailsPredictionsContentProps {
  feedback: Feedback;
  setSelectedLabels: SetSelectedLabels;
  selectedLabels: FeedbackLabel[];
}

export const FeedbackDetailsPredictionsContent = ({
  feedback,
  selectedLabels,
  setSelectedLabels,
}: FeedbackDetailsPredictionsContentProps) => {
  const editedRecords = useFeedbackOnFeedbackStore(
    ({ editedRecords }) => editedRecords,
  );
  const editedRecord = editedRecords.find(
    (editedRecord) => editedRecord.id === feedback.id,
  );

  const { entityLabels, reasonLabels, sentimentLabels } = useMemo(
    () => getFeedbackLabels(feedback.labels),
    [feedback.labels],
  );

  const sentiment = sentimentLabels?.[0];

  const editedSentiment = getSentimentPrediction(editedRecord)?.prediction;

  const labelSentiment: SentimentLabel =
    editedSentiment && editedSentiment !== SentimentName.Invalid
      ? {
          id: '',
          type: FeedbackLabelType.Sentiment,
          displayName: mapEdgeSentimentNameToSentimentName(editedSentiment),
          isVisible: true,
        }
      : sentiment;

  return (
    <Stack spacing={2}>
      <FeedbackCategories
        feedbackLabels={{ reasonLabels, entityLabels }}
        setSelectedLabels={setSelectedLabels}
        selectedLabels={selectedLabels}
        feedback={feedback}
        isDetailedView
      />
      {Boolean(sentiment) && (
        <>
          <Divider
            sx={{
              mb: 2,
            }}
          />
          <Stack spacing={0.5}>
            <Typography variant="body2" color="text.secondary">
              User Sentiment
            </Typography>
            <SentimentPredictionLabel
              label={labelSentiment}
              feedback={feedback}
            />
          </Stack>
        </>
      )}
    </Stack>
  );
};
